export function linkedOrganizationPath(organizationId: string): string {
  return `/linked-organizations/${organizationId}`;
}
